import resolveQueryStringToRecipient from 'owa-readwrite-recipient-well/lib/actions/resolveQueryStringToRecipient';
export default function resolveFindControlText(wellViewState) {
    if (wellViewState && wellViewState.queryString && wellViewState.queryString.length > 0) {
        resolveQueryStringToRecipient(wellViewState, true /*shouldDirectlyResolve */);
    }
}
//# sourceMappingURL=resolveFindControlText.js.map